import { FlightType } from '@search-bar/entities/flight-type';
import { SearchType } from '@search-bar/entities/search-type';
import { FlightClass } from '@shared/base-search-bar/entities/flight-class';
import { AutocompletePlaces } from '@search-bar/entities/autocomplete-places';
import { PassengerArrangementState } from '@shared/base-search-bar/entities/passenger-arrangement-state';
import { AutocompletePlace } from '@shared/base-search-bar/entities/autocomplete';
import { SelectAutocompletePlace } from '@search-bar/entities/select-autocomplete-place';
import { SelectAutocompletePrediction } from '@search-bar/entities/select-autocomplete-prediction';
import { GuestsPerRoomState } from '@shared/base-search-bar/store/reducers/guests-per-room.reducer';
import { PlaceType } from '@shared/base-search-bar/entities/place-type';
import { PackageStep } from '@packages/packages-search-bar/constants/package-step';
import { AutoCompleteDestination, InputDestinationPlace } from '@shared/base-search-bar/entities/autocomplete-destionation';
import { HeaderProductType } from '@app/modules/core/header/entities/ds-header-config';
import { AutoCompleteTravelExtra, InputTravelExtra } from '@shared/base-search-bar/entities/autocomplete-travel-extra';

export const searchBarFeatureName = 'baseSearchBarModuleState';

export type UISearchBarState = Readonly<{
  isLoadingAutocompletePlaces: boolean;
  placeTypeSelected: PlaceType;
  isSearchAirportForIp: boolean;
  isSearchTerminalForIp: boolean;
  isHeaderEditButtonVisible: boolean;
  autoDiffPlace: boolean;
  skipServices: boolean;
  tabSelectedHome: SearchType;
  editSearch: HeaderProductType;
}>;

export type SearchBarState = Readonly<{
  departurePlace: AutocompletePlace,
  arrivalPlace: AutocompletePlace,
  destinationPlace: AutocompletePlace,
  flightType: FlightType,
  hourType: string[],
  departureDate: Date,
  arrivalDate: Date,
  pickUpPlace: SelectAutocompletePrediction,
  dropOffPlace: SelectAutocompletePrediction,
  pickUpTime: string;
  dropOffTime: string;
  passengerArrangement: PassengerArrangementState,
  guestsPerRoom: GuestsPerRoomState,
  flightClass: FlightClass,
  defaultPlace: SelectAutocompletePlace,
  defaultAirport: SelectAutocompletePlace,
  departureTerminal: AutocompletePlace,
  arrivalTerminal: AutocompletePlace,
  autocompletePlaces: AutocompletePlaces,
  airline: string,
  baggageIncluded: boolean,
  branchCode: string,
  salesChannel: string,
  packageStep: PackageStep,
  autocompleteDestinationPlaces: AutoCompleteDestination,
  hotelDestinationPlace: InputDestinationPlace,
  packageDestinationPlace: InputDestinationPlace,
  packageOriginPlace: InputDestinationPlace,
  autocompleteExtra: AutoCompleteTravelExtra,
  inputTravelExtra: InputTravelExtra,
  ui: UISearchBarState,
}>;
